import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import Button from '../elements/Button'

const CountrySearch = (props) => {
    const inputEl = useRef(null)

    return (
        <div className='country-search d-flex w-100 justify-content-center align-items-center mb-5'>
            <label className='mr-3'>{props.title}</label>
            <div className={`input-container d-flex position-relative mt-3 mt-lg-0 ${props.countryList.length > 0 ? 'has-results' : ''}`}>
                <input
                    type='text'
                    value={props.search}
                    placeholder='Enter country here...'
                    ref={inputEl}
                    onChange={props.handleChange}
                    onFocus={() => inputEl.current.select()}
                />
                <Button action={event => event.preventDefault()} title='Search' />

                {props.countryList.length > 0
                    ? <div className='country-list'>
                        {props.countryList.map((item, key) => {
                            return <a href='#' onClick={event => props.handleSelect(event, item, inputEl)} key={key}>{item.country}</a>
                        })}
                      </div>
                    : ''}
            </div>
        </div>
    )
}

CountrySearch.propTypes = {
    title: PropTypes.string.isRequired,
    countryList: PropTypes.array.isRequired,
    search: PropTypes.string,
    handleChange: PropTypes.func.isRequired,
    handleSelect: PropTypes.func.isRequired
}

export default CountrySearch



// WEBPACK FOOTER //
// ./resources/js/components/CountrySearch.js